/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from "react";
import missingMonsterImg from 'dndimages/MissingMonster2.png';

interface MonsterUnavailableModalProps {
  isOpen: boolean;
  onClose: () => void;
  username?: string;
  monsterName?: string;
}

// Shown when a /monsterforge/mon/:username/:monstername share link points at a monster that can no
// longer be fetched as public (made private, pending, deleted, or the user/name no longer exists).
const MonsterUnavailableModal: React.FC<MonsterUnavailableModalProps> = ({ isOpen, onClose, username, monsterName }) => {
  if (!isOpen) return null;

  const named = monsterName ? `"${monsterName}"` : 'This monster';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{width: '400px', height: '600px'}} onClick={(e) => e.stopPropagation()}>
        <span className="modal-title" style={{display: 'block', textAlign: 'center'}}>Monster Not Found!
          <br/>
          <img src={missingMonsterImg} alt="Monster Not Found" height='400px' />
        </span>
        <div>
          <p>Sorry, <b>{named}</b>{username ? <> by <i>{username}</i></> : null} is no longer available.
          It may have been made private or removed by its owner.</p>
          <p> -- Or it may have escaped, but that's highly unlikely - our cages are very strong.</p>
        </div>
        <div className="modal-actions" style={{textAlign: 'center'}}>
          <button type="button" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default MonsterUnavailableModal;
